
export default function (value) {
  var plusminus = Math.round(Math.random()) ? -1 : 1

  return plusminus * value
}
